document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector(".custom-header");
  const sectionHeader = document.querySelector(".section-header");

  if (!header && !sectionHeader) return;

  let lastKnownScrollY = window.scrollY;
  let ticking = false;

  const updateHeaderState = () => {
    if (lastKnownScrollY > 80) {
      header?.classList.add("scrolled");
      sectionHeader?.classList.add("scrolled");
    } else {
      header?.classList.remove("scrolled");
      sectionHeader?.classList.remove("scrolled");
    }
    ticking = false;
  };

  const onScroll = () => {
    lastKnownScrollY = window.scrollY;
    if (!ticking) {
      requestAnimationFrame(updateHeaderState);
      ticking = true;
    }
  };

  updateHeaderState();

  window.addEventListener("scroll", onScroll);
});

document.addEventListener('DOMContentLoaded', () => {
  const cartDrawer = document.querySelector('cart-drawer');

  document.querySelectorAll('.cart-opener').forEach((opener) => {
    opener.addEventListener('click', (event) => {
      event.preventDefault(); 
      if (cartDrawer) {
        cartDrawer.open(opener);
      }
    });
  });
});
